import TVMCalculator from "../TVMCalculator";

export function CalculatorPage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Investment Calculator</h2>
        <p className="text-muted-foreground">Calculate deal metrics and returns</p>
      </div>

      <TVMCalculator />
    </div>
  );
}